module.exports = __webpack_public_path__ + "silver.4b1e51b2.jpg";